export default "__VITE_ASSET__YQRbjWHa__"